
// => Icons
import {
    IoSettings,
    IoDice,
    IoHelpCircle,
    IoRocket,
    IoCart,
} from "react-icons/io5";


export const menuItems = [
    {
        title: "Roulette",
        desc: "",
        clip: "assets/system/menu/item_regular.mp4",
        icon: <IoDice />,
        onClick: () => { alert('Regular mode not implemented yet.') },
        color: '#b24f68',
        locked: false,
    },
    {
        title: "JOI",
        desc: "",
        clip: "assets/system/menu/item_joi.mp4",
        icon: <IoRocket />,
        onClick: () => { alert('JOI mode not implemented yet.') },
        color: '#b24fb0',
        locked: true,
    },
    /*{
        title: "??????",
        desc: "",
        clip: "assets/system/menu/item_unknown.mp4",
        icon: <IoHelpCircle />,
        onClick: () => { alert('Not implemented yet.') },
        color: '#4fb272',
        locked: false,
    },*/
    {
        title: "Shop",
        desc: "",
        clip: "assets/system/menu/item_shop.mp4",
        icon: <IoCart />,
        onClick: () => { alert('Shop not implemented yet.') },
        color: '#b24f68',
        locked: false,
    },
    {
        title: "Settings",
        desc: "Change your game settings, content preferences and add custom content.",
        clip: "assets/system/menu/item_settings.mp4",
        icon: <IoSettings />,
        onClick: () => { alert('Settings not implemented yet.') },
        color: '#b24fb0',
        locked: false,
    },
]